// extracted by mini-css-extract-plugin
module.exports =  {"card":"Card-module__card___t3s26","card__header":"Card-module__card__header___reBmA","card__body":"Card-module__card__body___dvXxU"};